"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var profile_api_1 = require("@l2p/profile-api");
var date_fns_1 = require("date-fns");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var Elements_1 = require("../Elements");
var FullInfo_1 = __importDefault(require("../Elements/FullInfo"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var MobileRow = function (_a) {
    var title = _a.title, content = _a.content, added = _a.added, status = _a.status, expireDate = _a.expireDate, idx = _a.idx, amount = _a.amount, type = _a.type, balance = _a.balance, currency = _a.currency, startWageringBalance = _a.startWageringBalance, wageringBalance = _a.wageringBalance, startBalance = _a.startBalance;
    var t = (0, next_intl_1.useTranslations)('translation');
    var _b = (0, react_1.useState)(false), isExpanded = _b[0], setExpanded = _b[1];
    var handleCollapseClick = function () {
        setExpanded(function (prev) { return !prev; });
    };
    var fullInfoRows = (0, react_1.useMemo)(function () {
        var result = [];
        result.push({
            property: 'completed',
            value: (0, date_fns_1.format)(new Date(expireDate), 'HH:mm, dd-LL-yy'),
        });
        if (type === apps_shared_1.BonusTypes.FREESPINS) {
            var reward = balance;
            if (status !== profile_api_1.FreeRoundStatus.Finished)
                reward = 0;
            result.push({
                property: 'freespinWinnings',
                value: "".concat((0, apps_shared_1.getCurrencySymbol)(currency), " ").concat(Number(reward).toFixed(2)),
            });
        }
        if (type === apps_shared_1.BonusTypes.BONUSES)
            result.push({
                property: 'amountWagered',
                value: (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("span", { className: styles_module_scss_1.default.bonusConditionsHighlight }, "".concat((0, apps_shared_1.getCurrencySymbol)(currency), " ").concat(Number(Number(startWageringBalance || 0) - Number(wageringBalance || 0)).toFixed(2))), " / ".concat((0, apps_shared_1.getCurrencySymbol)(currency), " ").concat(Number(startWageringBalance).toFixed(2)))),
            });
        if (type === apps_shared_1.BonusTypes.BONUSES) {
            result.push({
                property: 'reward',
                value: type === apps_shared_1.BonusTypes.BONUSES
                    ? "".concat((0, apps_shared_1.getCurrencySymbol)(currency), " ").concat(Number(startBalance).toFixed(2))
                    : "".concat(amount, " ").concat(t('freespins')),
            });
        }
        return result;
    }, [
        t,
        amount,
        balance,
        wageringBalance,
        startBalance,
        currency,
        expireDate,
        startWageringBalance,
        status,
        type,
    ]);
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(idx % 2 === 0 ? styles_module_scss_1.default.odd : ''), onClick: handleCollapseClick },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.rowHead },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, title),
            react_1.default.createElement(Elements_1.Collapse, { isExpanded: isExpanded })),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.caption }, t('content')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.caption }, t('added')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.caption }, t('status'))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.row },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.content }, content),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.content }, added),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.status }, status)),
        isExpanded && react_1.default.createElement(FullInfo_1.default, { data: fullInfoRows })));
};
exports.default = MobileRow;
